import React from "react";
import Swal from "sweetalert2";

const ReceipeDetail = (props) => {
  let options = [];
  if (props.listInfo != undefined) {
    options.push({ value: "", info: "Select RMPM" });
    Object.keys(props.listInfo).forEach((key) => {
      options.push({
        value: props.listInfo[key],
        info: props.listInfo[key],
        selected: props.selected,
      });
    });
  } else {
    options.push({
      value: "",
      info: "No RMPM Found",
      selected: null,
    });
  }
  const removeList = (index) => {
    props.remove(index);
  };
  const handleInputChange = (e, index) => {
    props.listInputChange(e, index);
  };
  const handleQtyChange = (e, index) => {
    const name = e.target.name;
    const raw = e.target.value;

    // allow empty string so user can clear the field
    if (raw === "") {
      props.listInputChange(e, index);
      return;
    }

    const value = parseFloat(raw);

    // Determine max stock based on kitchen type if provided
    let max = Infinity;
    if (props.listInfo) {
      if (props.kitchenType === "ac" && props.listInfo.ac_conversion_qty !== undefined) {
        max = parseFloat(props.listInfo.ac_conversion_qty);
      } else if (props.kitchenType === "nonac" && props.listInfo.non_ac_conversion_qty !== undefined) {
        max = parseFloat(props.listInfo.non_ac_conversion_qty);
      } else if (props.kitchenType === "hotel_staff" && props.listInfo.staff_conversion_qty !== undefined) {
        max = parseFloat(props.listInfo.staff_conversion_qty);
      } else if (props.kitchenType === "bus_staff" && props.listInfo.others_conversion_qty !== undefined) {
        max = parseFloat(props.listInfo.others_conversion_qty);
      } else if (props.listInfo.current_stock !== undefined || props.listInfo.stock_qty !== undefined) {
        max = parseFloat(props.listInfo.current_stock || props.listInfo.stock_qty);
      }
    }

    if (!isNaN(value) && value > max && !props.noStockCheck) {
      Swal.fire({
        title: "Error",
        text: `Cannot exceed available stock (${max}).`,
        icon: "error",
        confirmButtonText: "Ok",
      });

      // send corrected value (max) back to parent
      props.listInputChange({ target: { name: name, value: String(max) } }, index);
      return;
    }

    // normal case
    props.listInputChange(e, index);
  };
  console.log(props.listInfo,'props.listInfo');
  
  return (
    <tr>
      <td>{props.listInfo.code}</td>
      <td>
        {props.listInfo.name}
      </td>
      <td>
        <input
          type="number"
          className="form-control"
          name="issue_qty"
          min={1}
          max={
            props.listInfo.current_stock === undefined
              ? ""
              : props.listInfo.current_stock
          }
          value={
            props.listInfo.issue_qty === undefined ? "" : props.listInfo.issue_qty
          }
          onChange={(e) => handleQtyChange(e, props.listSl)}
        />

        <p style={{ color: "red", textAlign: "center", marginTop: "10px" }}>
          {props.listInfo.qty < 0.0001 ? "0 Are Not Allowed" : ""}
        </p>
      </td>
      <td>
        <textarea
          className="form-control"
          name="remarks"
          value={props.listInfo.remarks || ""}
          onChange={(e) => handleInputChange(e, props.listSl)}
          placeholder="Remarks"
        ></textarea>
      </td>
      <td className="text-center">
        <button
          className="btn btn-danger btn-sm"
          onClick={() => removeList(props.listSl)}
        >
          <i className="fa fa-trash"></i>
        </button>
      </td>
    </tr>
  );
};

export default ReceipeDetail;
